import { Reducer } from "@reduxjs/toolkit";
import { StationVisitCount } from "./queryStationStatus";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { AsyncEntityState, createForeignKeySelector } from "../../../Store/Thunks/asyncEntityStateUtil";
import { RootState } from "../../../Store";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { fetchStationVisitCountByStationIdsThunk } from "../../../Store/Thunks/stationStatusByIds";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";

// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice({
  name: "stationVisitCount",
  reducers: {
    },
  fetchByIdsThunk: fetchStationVisitCountByStationIdsThunk,
  selectId:(stationVisitCount) => stationVisitCount.stationId
})

export const stationVisitCountReducer = reducer as Reducer<AsyncEntityState<StationVisitCount, number>>;

const selectState = (state: RootState) => state.graphQlData.stationVisitCount;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectStationVisitCountById, selectAll: SelectAllStationVisitCount} = entityAdapter.getSelectors(selectState);

const stationVisitCountByIdFetcher = new EnqueueFetcher(fetchStationVisitCountByStationIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

export const upsertStationVisitCount = upsertMany;

export const dispatchFetchStationVisitCountById = stationVisitCountByIdFetcher.enqueueFetchById;

export const {selectEntitiesByForeignKey: selectStationVisitCountByStationId} = createForeignKeySelector<StationVisitCount, number, AsyncEntityState<StationVisitCount, number>, number>((state) => state.graphQlData.stationVisitCount, "stationId");
const selectLoadingIds = getSelectors(selectState).selectLoadingIds;

export const useStationVisitCountById = entityByIdWithStatusHookFactory<StationVisitCount, number>(stationVisitCountByIdFetcher.enqueueFetchById, selectStationVisitCountById, selectLoadingIds)

